<div class="queue-container">
  <div class="queue-header">
    <h2>Timecards</h2>
    <span class="spacer"></span>
    <button mat-icon-button (click)="load()" matTooltip="Refresh" [disabled]="loading()">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>

  @if (loading()) {
    <div class="queue-loading"><mat-spinner diameter="36"></mat-spinner></div>
  } @else {
    @if (adminView()) {
      <div class="admin-note">Viewing all submitted timecards · System Administrator</div>
    }
    <mat-tab-group>
      <mat-tab label="{{ adminView() ? 'For Review' : 'For My Review' }} ({{ reviewQueue().length }})">
        <ng-container *ngTemplateOutlet="list; context: { rows: reviewQueue(), role: 'reviewer' }"></ng-container>
      </mat-tab>
      <mat-tab label="{{ adminView() ? 'For Approval' : 'For My Approval' }} ({{ approvalQueue().length }})">
        <ng-container *ngTemplateOutlet="list; context: { rows: approvalQueue(), role: 'approver' }"></ng-container>
      </mat-tab>
    </mat-tab-group>
  }
</div>

<ng-template #list let-rows="rows" let-role="role">
  <div class="queue-list">
    @if (rows.length === 0) {
      <p class="queue-empty">Nothing here right now.</p>
    }
    @for (row of rows; track row.principalEmail + row.periodKey) {
      <mat-card class="queue-card">
        <div class="queue-card-main">
          <div class="queue-card-info">
            <span class="hcp-name">{{ displayName(row) }}</span>
            <span class="hcp-email">{{ row.principalEmail }}</span>
          </div>
          <div class="queue-card-meta">
            <span class="period">{{ row.periodKey }}</span>
            <span>{{ formatHours(row.totalHours) }} hrs</span>
            <!-- totalAmount is a vestigial field on the timecard submission shape (carried over
                 from timesheets). Timecards are hours-only — there is no rate→dollar source
                 anywhere upstream, so it is always 0. Deliberately not rendered. -->

          </div>
        </div>

        @if (contractsFor(row).length) {
          <div class="queue-card-contracts">
            <span class="contracts-label">{{ contractsFor(row).length === 1 ? 'Contract' : 'Contracts' }}</span>
            <div class="contract-lines">
              @for (c of contractsFor(row); track c.contractId) {
                <span class="contract-line">
                  <span class="contract-name">{{ c.contractName || '(unnamed contract)' }}</span>
                  <span class="contract-id">{{ c.contractId }}</span>
                </span>
              }
            </div>
          </div>
        }

        <div class="queue-card-activities">
          <span class="activities-label">What they did</span>

          @if (shiftsFor(row).length) {
            <div class="shift-lines">
              @for (s of shiftsFor(row); track s.date + s.activity + s.startTime) {
                <div class="shift-line">
                  <div class="shift-head">
                    <span class="shift-date">{{ formatWorkDate(s.date) }}</span>
                    <span class="shift-activity">{{ s.activity }}</span>
                    <span class="shift-hours">{{ formatHours(s.hours) }} hrs</span>
                  </div>
                  @if (shiftMeta(s)) {
                    <div class="shift-meta">{{ shiftMeta(s) }}</div>
                  }
                  @if (s.details) {
                    <div class="shift-details">“{{ s.details }}”</div>
                  }
                </div>
              }
            </div>
          }

          @if (breakdownFor(row).length) {
            <span class="activities-label sub">Hours by activity</span>
            <div class="activity-lines">
              @for (line of breakdownFor(row); track line.name) {
                <span class="activity-line">
                  <span class="activity-name">{{ line.name }}</span>
                  <span class="activity-hours">{{ formatHours(line.hours) }} hrs</span>
                </span>
              }
            </div>
          }

          <div class="activity-lines">
            <span class="activity-line activity-total">
              <span class="activity-name">Total hours</span>
              <span class="activity-hours">{{ formatHours(totalHoursFor(row)) }} hrs</span>
            </span>
          </div>
        </div>

        <div class="queue-card-actions">
          <button mat-flat-button color="primary" [disabled]="acting()"
            (click)="startAction(row, role, 'approve')">Approve</button>
          <button mat-stroked-button [disabled]="acting()"
            (click)="startAction(row, role, 'return')">Return to owner</button>
        </div>

        @if (isOpen(row, 'return')) {
          <div class="queue-reason">
            <mat-form-field appearance="outline" class="reason-field" subscriptSizing="dynamic">
              <mat-label>Note (required)</mat-label>
              <textarea matInput rows="2" [(ngModel)]="noteText"
                placeholder="Why is this being returned? The owner is emailed this."></textarea>
            </mat-form-field>
            <div class="queue-reason-actions">
              <button mat-button (click)="cancelAction()">Cancel</button>
              <button mat-flat-button color="warn" [disabled]="acting()"
                (click)="confirmAction(row, role, 'return')">
                Confirm
              </button>
            </div>
          </div>
        }
      </mat-card>
    }
  </div>
</ng-template>
